import { LONG_DASH } from 'v2/constants';
import { Nullable } from 'v2/types';

interface UserContactSource {
  telegramUserName?: Nullable<string>;
  email?: Nullable<string>;
}

export const isEmailLike = (value: string): boolean => /^[^@\s]+@[^@\s]+$/.test(value.trim());

export const normalizeContact = (value: string): string => value.trim().toLowerCase().replace(/^@/, '');

export const getUserContact = ({ telegramUserName, email }: UserContactSource): string => {
  if (telegramUserName) {
    return `@${telegramUserName}`;
  }

  if (email) {
    return email;
  }

  return LONG_DASH;
};

export const formatUnknownContact = (value: string): string => {
  const trimmedValue = value.trim();

  return isEmailLike(trimmedValue) ? trimmedValue : `@${trimmedValue.replace(/^@/, '')}`;
};
